<template>
    <div>
        <c-column-header
            class="primary"
            :label="title"
        >
            <template v-slot:filter>
                <div style="margin-top: -1px">
                    <c-toolbar-button
                        icon     = "mdi-refresh"
                        :tooltip = "$t('common.refresh')"
                        color    = "white"
                        size     = "20"
                        @click   = "onRefresh"
                    />
                </div>
            </template>
        </c-column-header>
        <v-progress-linear
            v-if   = "loading"
            color  = "secondary"
            height = "4"
            class  = "w-100 mt-0"
            indeterminate
        />
        <div class="mt-1" v-if="!loading">

        </div>
        <div class="mt-0 lm-border pa-2" style="height: 430px">
            <div class="pr-1" style="overflow-y: scroll; max-height: 412px;">
                <!-- iot-api-svc's /sites/{id}/events only guarantees triggeredAt/receivedAt/type for a
                     RIDE event - the old per-door/per-direction sensor icons relied on fields
                     (direction, sensor, recorded) the new event model doesn't provide, so rides are
                     now shown as a plain timestamp list. -->
                <div v-for="(movement, index) in movements" :key="index" class="v-flex ml-5 ride-row">
                    <div class="vMovement">
                        <v-icon color="white">mdi-elevator</v-icon>
                    </div>

                    <div class="pl-2" style="font-size: 15px">
                        {{ format (movement.triggeredAt) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Core from "@/modules/core/service/Core";
import Datahub from "@/modules/datahub/service/Datahub";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader.vue";

export default {
    name: "WSiteMovements",
    components: {
        CColumnHeader,
        CToolbarButton
    },

    props: {
        unit: {

        }
    },

    data: () => ({
        loading: false,
        currentUnitId: null,
        date: null,
        movements: [],
    }),

    computed: {
        dashboardId () {
            return this.unit.dashboardId ? this.unit.dashboardId : this.unit.id;
        },

        title () {
            return this.$t('movements.title') + (this.date ? ": " + this.date : "");
        }
    },

    mounted() {
        this.load();
    },

    watch: {
        unit () {
            this.load();
        }
    },

    methods: {
        load () {
            if (!this.unit) {
                return;
            }

            if (this.unit.id === this.currentUnitId) {
                return;
            }

            this.loading = true;
            this.currentUnitId = this.unit.id;
            this.date = null;
            Datahub.lastMovements(this.unit.id, 24).then((data) => {
                if (data && data.length > 0) {
                    this.date = Core.format.date.display(data[0].triggeredAt);
                }

                this.movements = data;
                this.loading = false;
            })
        },

        onRefresh () {
            this.currentUnitId = null;
            this.load();
        },

        format (value) {
            return Core.format.time(value);
        }
    }
}
</script>

<style scoped>

.ride-row {
    align-items: center;
    margin-bottom: 2px;
}

.vMovement {
    background-color: black;
    height: 24px;
    width: 24px;
    padding-left: 2px;
    padding-top: 1px;
    margin-left: 84px;
    display: flex;
    align-items: center;
}

</style>